import React, { useState } from 'react';

import { Instruction } from '../../floor-plan-map/floor-plan-map.interface';

export interface CarouselProps {
  slides: Array<Instruction>;
  className: string;
  shopHeader: string;
  routePreference: string;
  currentSlide: number;
  nextSlide: () => void;
  prevSlide: () => void;
}

const Carousel = ({
  slides,
  className,
  shopHeader,
  routePreference,
  currentSlide,
  nextSlide,
  prevSlide,
}: CarouselProps) => {
  const __imagePath = '/visioweb/images';

  const [touchStartX, setTouchStartX] = useState(0);

  const handleTouchStart = (e: any) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchEnd = (e: any) => {
    const touchEndX = e.changedTouches[0].clientX;
    if (touchStartX - touchEndX > 50) {
      nextSlide();
    } else if (touchStartX - touchEndX < -50) {
      prevSlide();
    }
  };

  return (
    <div
      className={`carousel ${className}`}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <div className="fixed-carousel-header align-center flex pl-5 pt-5">
        <div className="font-title text-headings">{shopHeader}</div>
        <div className="ml-3 text-bodym text-neutral-grey-700">
          {routePreference}
        </div>
      </div>
      <div
        className="carousel-slides flex transition-transform duration-300 ease-in-out"
        style={{
          transform: `translateX(-${currentSlide * 100}%)`,
        }}
      >
        {slides.map((slide, index) => (
          <div className="carousel-slide min-w-full px-5 pb-5" key={index}>
            <div className="header mb-2 flex"></div>
            <div className="flex justify-between">
              <div className="w-[85%] text-bodym">{slide?.detail}</div>
              <img
                className="h-9 w-9"
                src={__imagePath + '/' + slide?.icon}
                alt={`Slide ${index + 1}`}
              />
            </div>
          </div>
        ))}
      </div>
      <div className="carousel-indicator absolute bottom-2.5 left-1/2 flex -translate-x-1/2 gap-2.5">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`indicator-dot h-2.5 transition-colors duration-300 ease-in-out ${
              currentSlide === index
                ? 'active w-6 rounded-[40px] bg-neutral-grey-700'
                : 'w-2.5 rounded-full bg-neutral-grey-400'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
